<section id="home" class="slider_area">
    <div class="carousel-inner">
        <div class="carousel-item active">
            <div class="slider-content">&nbsp;</div>
        </div>
    </div>
</section>

<section class="hero bg-primary text-white py-5">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <h1 class="display-4 fw-bold mb-4">{{ 'ABOUT_US.HERO.TITLE' | translate }}</h1>
                <p class="lead mb-4">{{ 'ABOUT_US.HERO.SUBTITLE' | translate }}</p>
                <a href="/about-us#contact" class="btn btn-light btn-lg">{{ 'ABOUT_US.HERO.CTA' | translate }}</a>
            </div>
            <div class="col-lg-6">
                <img src="assets/images/about.jpg" alt="About Us" class="img-fluid rounded shadow">
            </div>
        </div>
    </div>
</section>

<section class="story py-5">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <h2 class="section-title mb-4">{{ 'ABOUT_US.STORY.TITLE' | translate }}</h2>
                <p class="lead mb-4">{{ 'ABOUT_US.STORY.INTRO' | translate }}</p>
                <p>{{ 'ABOUT_US.STORY.CONTENT' | translate }}</p>
            </div>
            <div class="col-lg-6">
                <div class="timeline">
                    <div class="timeline-item">
                        <div class="year">2020</div>
                        <div class="content">
                            <h4>{{ 'ABOUT_US.STORY.TIMELINE.2020.TITLE' | translate }}</h4>
                            <p>{{ 'ABOUT_US.STORY.TIMELINE.2020.DESCRIPTION' | translate }}</p>
                        </div>
                    </div>
                    <div class="timeline-item">
                        <div class="year">2021</div>
                        <div class="content">
                            <h4>{{ 'ABOUT_US.STORY.TIMELINE.2021.TITLE' | translate }}</h4>
                            <p>{{ 'ABOUT_US.STORY.TIMELINE.2021.DESCRIPTION' | translate }}</p>
                        </div>
                    </div>
                    <div class="timeline-item">
                        <div class="year">2022</div>
                        <div class="content">
                            <h4>{{ 'ABOUT_US.STORY.TIMELINE.2022.TITLE' | translate }}</h4>
                            <p>{{ 'ABOUT_US.STORY.TIMELINE.2022.DESCRIPTION' | translate }}</p>
                        </div>
                    </div>
                    <div class="timeline-item">
                        <div class="year">2023</div>
                        <div class="content">
                            <h4>{{ 'ABOUT_US.STORY.TIMELINE.2023.TITLE' | translate }}</h4>
                            <p>{{ 'ABOUT_US.STORY.TIMELINE.2023.DESCRIPTION' | translate }}</p>
                        </div>
                    </div>
                    <div class="timeline-item">
                        <div class="year">2024</div>
                        <div class="content">
                            <h4>{{ 'ABOUT_US.STORY.TIMELINE.2024.TITLE' | translate }}</h4>
                            <p>{{ 'ABOUT_US.STORY.TIMELINE.2024.DESCRIPTION' | translate }}</p>
                        </div>
                    </div>
                    <div class="timeline-item future">
                        <div class="year">2025</div>
                        <div class="content">
                            <h4>{{ 'ABOUT_US.STORY.TIMELINE.2025.TITLE' | translate }}</h4>
                            <p>{{ 'ABOUT_US.STORY.TIMELINE.2025.DESCRIPTION' | translate }}</p>
                        </div>
                    </div>
                    <div class="timeline-item future">
                        <div class="year">2026</div>
                        <div class="content">
                            <h4>{{ 'ABOUT_US.STORY.TIMELINE.2026.TITLE' | translate }}</h4>
                            <p>{{ 'ABOUT_US.STORY.TIMELINE.2026.DESCRIPTION' | translate }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="mission bg-light py-5">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <img src="assets/images/team-1.jpg" alt="Our Mission" class="img-fluid rounded shadow">
            </div>
            <div class="col-lg-6">
                <h2 class="section-title mb-4">{{ 'ABOUT_US.MISSION.TITLE' | translate }}</h2>
                <p class="lead mb-4">{{ 'ABOUT_US.MISSION.SUBTITLE' | translate }}</p>
                <p>{{ 'ABOUT_US.MISSION.CONTENT' | translate }}</p>
                <div class="mt-4">
                    <h3>{{ 'ABOUT_US.MISSION.VALUES.TITLE' | translate }}</h3>
                    <ul class="list-unstyled">
                        <li class="mb-3">
                            <i class="fas fa-check-circle text-primary me-2"></i>
                            {{ 'ABOUT_US.MISSION.VALUES.INNOVATION' | translate }}
                        </li>
                        <li class="mb-3">
                            <i class="fas fa-check-circle text-primary me-2"></i>
                            {{ 'ABOUT_US.MISSION.VALUES.QUALITY' | translate }}
                        </li>
                        <li class="mb-3">
                            <i class="fas fa-check-circle text-primary me-2"></i>
                            {{ 'ABOUT_US.MISSION.VALUES.INTEGRITY' | translate }}
                        </li>
                        <li class="mb-3">
                            <i class="fas fa-check-circle text-primary me-2"></i>
                            {{ 'ABOUT_US.MISSION.VALUES.CUSTOMER_FOCUS' | translate }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="team py-5">
    <div class="container">
        <h2 class="section-title text-center mb-5">{{ 'ABOUT_US.TEAM.TITLE' | translate }}</h2>
        <div class="row">
            <div class="col-md-4 mb-4">
                <div class="team-member text-center">
                    <img src="assets/images/team-1.jpg" alt="Team Member" class="rounded-circle mb-3">
                    <h4>{{ 'ABOUT_US.TEAM.MEMBER1.NAME' | translate }}</h4>
                    <p class="text-muted">{{ 'ABOUT_US.TEAM.MEMBER1.POSITION' | translate }}</p>
                    <p>{{ 'ABOUT_US.TEAM.MEMBER1.DESCRIPTION' | translate }}</p>
                </div>
            </div>
            <div class="col-md-4 mb-4">
                <div class="team-member text-center">
                    <img src="assets/images/team-2.jpg" alt="Team Member" class="rounded-circle mb-3">
                    <h4>{{ 'ABOUT_US.TEAM.MEMBER2.NAME' | translate }}</h4>
                    <p class="text-muted">{{ 'ABOUT_US.TEAM.MEMBER2.POSITION' | translate }}</p>
                    <p>{{ 'ABOUT_US.TEAM.MEMBER2.DESCRIPTION' | translate }}</p>
                </div>
            </div>
            <div class="col-md-4 mb-4">
                <div class="team-member text-center">
                    <img src="assets/images/team-3.jpg" alt="Team Member" class="rounded-circle mb-3">
                    <h4>{{ 'ABOUT_US.TEAM.MEMBER3.NAME' | translate }}</h4>
                    <p class="text-muted">{{ 'ABOUT_US.TEAM.MEMBER3.POSITION' | translate }}</p>
                    <p>{{ 'ABOUT_US.TEAM.MEMBER3.DESCRIPTION' | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="contact" class="contact py-5 bg-light">
    <div class="container">
        <h2 class="section-title text-center mb-5">{{ 'ABOUT_US.CONTACT.TITLE' | translate }}</h2>
        <div class="row">
            <div class="col-lg-6">
                <form #contactForm="ngForm" (ngSubmit)="send()">
                    <div class="mb-3">
                        <label for="name" class="form-label">{{ 'ABOUT_US.CONTACT.FORM.NAME' | translate }}</label>
                        <input 
                            type="text" 
                            class="form-control" 
                            id="name" 
                            name="name"
                            placeholder="{{ 'ABOUT_US.CONTACT.FORM.NAME' | translate }}"
                            [(ngModel)]="contactItem.subject"
                            required
                        >
                    </div>
                    <div class="mb-3">
                        <label for="email" class="form-label">{{ 'ABOUT_US.CONTACT.FORM.EMAIL' | translate }}</label>
                        <input 
                            type="email" 
                            class="form-control" 
                            id="email" 
                            name="email"
                            placeholder="{{ 'ABOUT_US.CONTACT.FORM.EMAIL' | translate }}"
                            [(ngModel)]="contactItem.email"
                            required 
                            email
                        >
                    </div>
                    <div class="mb-3">
                        <label for="message" class="form-label">{{ 'ABOUT_US.CONTACT.FORM.MESSAGE' | translate }}</label>
                        <textarea 
                            class="form-control" 
                            id="message" 
                            rows="5" 
                            name="message"
                            placeholder="{{ 'ABOUT_US.CONTACT.FORM.MESSAGE' | translate }}"
                            [(ngModel)]="contactItem.content"
                            required
                        ></textarea>
                    </div>
                    <button 
                        type="submit" 
                        class="btn btn-primary"
                        [disabled]="contactForm.invalid || isLoading"
                        [ngClass]="{'loading': isLoading}"
                    >
                        <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
                        <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
                    </button>
                </form>
            </div>
            <div class="col-lg-6">
                <div class="contact-info">
                    <h3>{{ 'ABOUT_US.CONTACT.INFO.TITLE' | translate }}</h3>
                    <ul class="list-unstyled">
                        <li class="mb-3">
                            <i class="fas fa-phone text-primary me-2"></i>
                            {{ 'ABOUT_US.CONTACT.INFO.PHONE' | translate }}
                        </li>
                        <li class="mb-3">
                            <i class="fas fa-envelope text-primary me-2"></i>
                            {{ 'ABOUT_US.CONTACT.INFO.EMAIL' | translate }}
                        </li>
                    </ul>
                    <div class="social-links mt-4">
                        <a href="#" class="me-3"><i class="fab fa-facebook-f"></i></a>
                        <a href="#" class="me-3"><i class="fab fa-twitter"></i></a>
                        <a href="#" class="me-3"><i class="fab fa-linkedin-in"></i></a>
                        <a href="#"><i class="fab fa-instagram"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>